import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { SingleActionDialogModel } from '../../../interfaces/dialogs/single-action-dialog.model';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * 隱私條件dialog
 */
@Component({
  selector: 'app-private-policy-dialog',
  standalone: true,
  imports: [
            MatDialogContent, 
            MatButton,
            TranslatePipe,
          ],
  templateUrl: './private-policy-dialog.component.html',
  styleUrl: './private-policy-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PrivatePolicyDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PrivatePolicyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SingleActionDialogModel
  ) {}

  agree(event: Event) {
    event.stopPropagation();
    this.dialogRef.close('agree');
  }
  close() {
    this.dialogRef.close();
  }
}
